import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  closeIcon: {
    position: 'absolute',
    right: 20,
    top: 20,
  },
  content: {
    padding: isMobileApp
      ? '50px 20px 20px'
      : '20px 80px',
    margin: '10px auto',
    width: '100%',
    boxSizing: 'border-box',
  },
  buttonWrapper: {
    textAlign: 'right',
    marginTop: 20,
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class ReportCardsDetailsEditCommentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props?.data?.description ?? '',
    };

    this.axiosCancel = null;

    this.onChange = this.onChange.bind(this);
    this.onSaveButtonClick = this.onSaveButtonClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.id !== prevProps.data.id) {
      this.setState({
        value: '',
      });
    }
    if (this.props.data.description !== prevProps.data.description) {
      this.setState({
        value: this.props.data.description,
      });
    }
  }

  onChange(event) {
    this.setState({
      value: event.target.value,
    });
  }

  onSaveButtonClick() {
    const {
      data,
      pupilReportCardId,
      onSave,
    } = this.props;
    const {
      value,
    } = this.state;

    const url = data.id
      ? `${window.apiUrl}/editpupilreportcardcomment`
      : `${window.apiUrl}/addpupilreportcardcomment`;
    const params = {
      comment: value,
      pupil_report_card_id: pupilReportCardId,
      pupil_report_card_comment_id: data.id ?? 0,
    };

    axios
      .post(
        url,
        qs.stringify(params),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then(() => {
        this.setState({
          value: '',
        });

        if (onSave) {
          onSave();
        }
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      t,
      classes,
      isOpen,
      onClose,
    } = this.props;
    const {
      value,
    } = this.state;

    return (
      <Dialog
        fullScreen={isMobileApp}
        scroll="paper"
        open={isOpen}
        fullWidth
        maxWidth="md"
        onClose={onClose}
        TransitionComponent={Transition}
        className="report-cards-details-edit-comment-dialog"
      >
        <IconButton
          aria-label="Close"
          onClick={onClose}
          className={`report-cards-details-edit-comment-button ${classes.closeIcon}`}
        >
          <CloseIcon/>
        </IconButton>
        <div className={classes.content}>
          <TextField
            label={t('Comment')}
            value={value}
            onChange={this.onChange}
            multiline
            rows={3}
            fullWidth
          />
          <div className={classes.buttonWrapper}>
            <Button
              color="secondary"
              onClick={this.onSaveButtonClick}
              className={`report-cards-details-edit-comment-dialog-save-button ${classes.button}`}
            >
              {t('Save')}
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withSnackbar(withTranslation()(ReportCardsDetailsEditCommentDialog)));
